import { MessagePersona as MessagePersonaType } from '@web/conversations/types/Message';
import { MessageType } from '@web/conversations/types/MessageType';
import {
  MessageAlternativeLayout,
  MessageInfoText,
  MessageWrapper,
} from '@web/conversations/Message/MessageLayout/MessageLayout';

import { getAdditionMetaMessage, getRemovalMetaMessage } from './messagePersona.utils';

type Props = {
  message: MessagePersonaType;
};
export const MessagePersona = ({ message }: Props) => {
  const description =
    message.type === MessageType.ADDITION
      ? getAdditionMetaMessage(message)
      : getRemovalMetaMessage(message);

  return (
    <MessageAlternativeLayout>
      <MessageWrapper>
        <MessageInfoText>{description}</MessageInfoText>
      </MessageWrapper>
    </MessageAlternativeLayout>
  );
};
